module.exports = __webpack_public_path__ + "img/nothing-found.f967de1.png";